import React from 'react';
import { RecommendationsProps } from '../../types/score';

const RecommendationsSection: React.FC<RecommendationsProps> = ({ score }) => {
  return (
    <div className="mt-6">
      <div className="space-y-4">
        {score.categories[0].score < 50 && (
          <div className="flex items-start p-4 rounded-lg bg-blue-50">
            <div className="flex-shrink-0 bg-blue-100 rounded-full p-2 mr-4">
              <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-blue-800">Maturité Digitale</h4>
              <p className="text-blue-700">Investissez dans des outils digitaux pour améliorer l'efficacité de vos équipes</p>
            </div>
          </div>
        )}
        
        {score.categories[1].score < 50 && (
          <div className="flex items-start p-4 rounded-lg bg-indigo-50">
            <div className="flex-shrink-0 bg-indigo-100 rounded-full p-2 mr-4">
              <svg className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
              </svg>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-indigo-800">Acquisition & Marketing</h4>
              <p className="text-indigo-700">Améliorez votre stratégie de marketing digital et d'acquisition client</p>
            </div>
          </div>
        )}
        
        {score.categories[2].score < 50 && (
          <div className="flex items-start p-4 rounded-lg bg-purple-50">
            <div className="flex-shrink-0 bg-purple-100 rounded-full p-2 mr-4">
              <svg className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-purple-800">Innovation</h4>
              <p className="text-purple-700">Explorez des solutions innovantes pour vous démarquer de la concurrence</p>
            </div>
          </div>
        )}
        
        {score.overall < 70 && (
          <div className="flex items-start p-4 rounded-lg bg-gradient-to-r from-blue-100 to-indigo-100 border border-blue-200">
            <div className="flex-shrink-0 bg-blue-200 rounded-full p-2 mr-4">
              <svg className="h-6 w-6 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-blue-800">Plan d'action personnalisé</h4>
              <p className="text-blue-700">Contactez notre équipe pour recevoir un plan d'action détaillé et adapté à vos besoins spécifiques.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecommendationsSection;
